import { collection, getDocs, query, where } from 'firebase/firestore';
import Failure from '../../../core/Failure';
import { FirestoreCollections, firestore } from '../../../firebase.config';
import Subscription from '../../models/Subscription';

async function getSubscriptionsBySender(
  sender: string
): Promise<{
  subscriptions: Subscription[],
  totalCount: number
}> {
  try {
    const db = firestore;

    const senderQueryResults = await getDocs(
      query(
        collection(db, FirestoreCollections.subscriptions),
        where('sender', 'array-contains', sender)
      )
    );

    const subscriptions: Subscription[] = [];

    senderQueryResults.docs.forEach((doc) => {
      subscriptions.push(Subscription.fromFirestore(doc));
    });

    return {
      subscriptions,
      totalCount: subscriptions.length,
    };
  } catch (e) {
    console.log('error: ', e);
    throw new GetSubscriptionsBySenderFailure();
  }
}

export class GetSubscriptionsBySenderFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getSubscriptionsBySender;
